import React, { useState } from 'react';
import ImageListItem from '@mui/material/ImageListItem';
import ImageList from '@mui/material/ImageList';
import { Box, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useCol, useFirebase } from '../hooks/firebase';
import { Filepond } from '../components';
import _ from 'lodash';

export const Banner = () => {
    const { data, deleteRecord, createRecord } = useCol('banner');
    const [newImage, setNewImage] = useState({});
    const { storage } = useFirebase();

    const addImage = async () => {
        return await Object.values(newImage).map(async (cur, index) => {
            const storageRef = storage.ref();

            var uploadTask = await storageRef
                .child(`banner/${cur.name}`)
                .put(cur);

            const url = await uploadTask.ref.getDownloadURL();
            await createRecord('', {
                image: url,
            });
            setNewImage({});
        });
    };

    return (
        <Box
            overflow="scroll"
            fullWidth
            height="84vh"
            className="detail-container"
            p={3}
        >
            <ImageList cols={4}>
                {data.map((item, index) => (
                    <ImageListItem key={`banner-${index}`}>
                        <img
                            src={item.image}
                            srcSet={item.image}
                            alt={item.title}
                            loading="lazy"
                        />
                        <Box
                            position="absolute"
                            sx={{
                                background: 'black',
                                padding: '5px',
                                cursor: 'pointer',
                            }}
                            onClick={async () => {
                                await deleteRecord(item.id);
                            }}
                        >
                            <CloseIcon
                                sx={{
                                    width: '30px',
                                    height: '30px',
                                    color: 'white',
                                }}
                            />
                        </Box>
                    </ImageListItem>
                ))}
            </ImageList>
            <Filepond
                images={newImage}
                setImages={setNewImage}
                limit={1}
                allowMultiple={false}
            />

            <Button
                fullWidth
                onClick={addImage}
                variant="contained"
                color="primary"
            >
                Save
            </Button>
        </Box>
    );
};
